// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Define module-scoped variable inferring API base URL from window
 * location. This base URL will include the "/calculator" path since *any*
 * request from the frontend must *only* go via endpoints under that path.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
const baseUrl = /^https?:\/\/localhost:\d*/.test(window.location.href)
        ? "http://localhost:8080/calculator"
    : /^https?:\/\/(\d{0,3}\.?){4}:\d*/.test(window.location.href)
        ? "http://192.168.0.240:8080/calculator"
    : /^https:\/\/staging\..*$/.test(window.location.href)
        ? "https://staging.api.roof-calc.co.uk/calculator"
    : "https://api.roof-calc.co.uk/calculator"

// @@exports
export { baseUrl }
